import React, { useEffect } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextField } from '../shared/form/formik/FormikTextField'
import { Driver } from 'src/interfaces/driver'
import { useFormikContext } from 'formik'

interface DebitCardContentProps {
  handleChange: (e: React.ChangeEvent<any>) => void
  driver: Driver | null
}

const DATE_MASK = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

const CARD_NUMBER_MASK = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

export const DebitCardContent = ({ handleChange, driver }: DebitCardContentProps) => {
  const { values, setFieldValue } = useFormikContext<any>()

  const hasPrefilledName = !!values.nameOnCard

  useEffect(() => {
    if (driver && !values.nameOnCard) {
      const fullName = `${driver.firstName} ${driver.lastName}`.trim()

      setFieldValue('nameOnCard', fullName)
    }
  }, [driver, values.nameOnCard, setFieldValue])

  return (
    <>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="nameOnCard"
          placeholder="Enter name on card"
          label="Name on card"
          onChange={handleChange}
          disabled={hasPrefilledName}
          css={tw`w-full`}
        />
        {hasPrefilledName && (
          <div
            css={tw`mt-2 p-3 flex flex-row items-center rounded-2xl`}
            style={{ backgroundColor: 'var(--mui-shades-100)' }}
          >
            <div
              css={tw`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mr-3`}
              style={{ backgroundColor: '#4A3F57' }}
            >
              <Typography css={tw`text-white text-xs font-bold`}>i</Typography>
            </div>
            <div css={tw`flex flex-col`}>
              <Typography css={tw`text-sm`} style={{ color: '#4A3F57', fontSize: '16px' }}>
                Full name is prefilled with your verified
              </Typography>
              <Typography css={tw`text-sm`} style={{ color: '#4A3F57', fontSize: '16px' }}>
                legal name and can't be edited.
              </Typography>
              <Typography css={tw`text-sm`} style={{ color: '#4A3F57', fontSize: '16px' }}>
                Contact support if you need help.
              </Typography>
            </div>
          </div>
        )}
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="cardNumber"
          placeholder="Enter card number"
          label="Card number"
          mask={CARD_NUMBER_MASK}
          inputMode="numeric"
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="expirationDate"
          placeholder="MM-YYYY"
          label="Expiration date"
          mask={DATE_MASK}
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
      <div css={tw`mb-4`}>
        <FormikTextField
          name="zipCode"
          placeholder="Enter zip code"
          label="Zip code"
          onChange={handleChange}
          css={tw`w-full`}
        />
      </div>
    </>
  )
}
